import { STATIC_COLORS, COLORS as TAILWIND_COLORS } from '@oriola-corporation/config-tailwind';
import { DefaultTheme } from 'styled-components';

/**
 * This utility is used to access colors from the config-tailwind package and the styled-components default theme.
 * This is used in ui-components/src/theme/Theme.ts
 * We should remove this in favour of only using config-tailwind directly.
 */

export interface PropsWithTheme {
  theme: DefaultTheme;
}

const COLOR = (color: keyof DefaultTheme['colors']) => (props: PropsWithTheme) =>
  props.theme.colors[color];

export const COLORS = {
  GRAY_LIGHTER: COLOR('grayLighter'),
  GRAY_LIGHTEST: COLOR('grayLightest'),
  GRAY: COLOR('gray'),
  GRAY_DARKER: COLOR('grayDarker'),
  BUTTON_SECONDARY: COLOR('buttonSecondary'),
  BUTTON_SECONDARY_DARKER: COLOR('buttonSecondaryDarker'),
  BUTTON_PRIMARY: COLOR('buttonPrimary'),
  BUTTON_PRIMARY_DARKER: COLOR('buttonPrimaryDarker'),
  BUTTON_PRIMARY_HOVER: COLOR('buttonPrimaryHover'),
  TEXT: COLOR('text'),
  WHITE: COLOR('white'),
  SEPHIA: COLOR('sephia'),
  BLACK: COLOR('black'),
  BRAND: COLOR('brand'),
  PRIMARY: COLOR('primary'),
  PRIMARY_DARKER: COLOR('primaryDarker'),
  BACKGROUND: COLOR('background'),
  COMPONENT_BACKGROUND: COLOR('componentBackground'),
  COMPONENT_BACKGROUND_DARKER: COLOR('componentBackgroundDarker'),
  SUCCESS: COLOR('success'),
  WARNING: COLOR('warning'),
  ERROR: COLOR('error'),
} as const;

export { STATIC_COLORS, TAILWIND_COLORS };
